import styles from './videoSliderComponent.module.scss'
import Bubble from '../common/bubble/Bubble'
import { Flex } from '../common/flex/Flex'
import { Typography } from '../common/Typography/Typography'
import VideoSlider from '../videoSlider/VideoSlider'

const videoSliderComponent = () => {
  const title = 'Learn From Our Successes'
  const text =
    'Inspire your next idea from our past learnings. Our magic is in our people and these case studies can take you there.'
  const bubbleText = 'Take a sip of the future'
  return (
    <div className={styles.sliderSubheadContainer}>
      <Flex direction="column" className={styles.contentContainer}>
        <Typography className={styles.title}>{title}</Typography>
        <Typography className={styles.text}>{text}</Typography>
        <Bubble color="#E4FF3C" text={bubbleText} direction="down" className={styles.bubble} />
        <div className={styles.shineContainer}>
          <svg width="54" height="50" viewBox="0 0 54 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 47L37 47" stroke="#EBFF00" strokeWidth="5" strokeLinecap="round" />
            <path
              d="M38 31C31.1852 27.6266 22.8461 24.402 17 20"
              stroke="#EBFF00"
              strokeWidth="5"
              strokeLinecap="round"
            />
            <path d="M51 3V26" stroke="#EBFF00" strokeWidth="5" strokeLinecap="round" />
          </svg>
        </div>
      </Flex>
      <div className={styles.sliderContainer}>
        <VideoSlider />
      </div>
    </div>
  )
}

export default videoSliderComponent
